import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { CodeDbList, CodeTpListCode } from 'lib/api/server';
import { showSuccessSnackbar } from 'modules/snackbar';

import Icon from 'components/atoms/Icon';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import AutoComplete from 'components/molecules/NewSelectBox/AutoComplete';

const CodeSetting = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [initialization, setInitialization] = useState(false);
  const initParams = {};
  const [params, setParams] = useState(initParams);
  const initList = [];
  const [list, setList] = useState(initList);

  useEffect(() => {
    CodeTpListCode()
      .then((response) => {
        setList(response.data.data);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  const getParam = (newParams, name) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams, name);
    }
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    CODE_TP_ID: { bodyStyle: { width: 300 } },
    CODE_ID: { bodyStyle: { width: 150 } },
    CODE_VAL: { bodyStyle: { width: 150 } },
    REG_USER_ID: { bodyStyle: { width: 100 } },
    USE_YN: {
      makeHead: (headsMap) => {
        return t('사용여부');
      },
      makeBody: (rowObj, headsMap) => {
        return (
          <Icon
            icon="faPowerOff"
            style={
              rowObj.USE_YN === '01'
                ? { color: '#79bd2f' }
                : { color: '#6d6d6d' }
            }
          />
        );
      },
      bodyStyle: { width: 100 },
    },
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <NewFilterWrap>
        <AutoComplete
          list={list}
          label={t('코드유형')}
          name="codeTpId"
          valueKey="CODE_TP_ID"
          labelKey="CODE_LABEL"
          getParam={getParam}
          params={params}
          type="filter"
          style={{ width: 250 }}
        />
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={CodeDbList}
        customized={customized}
        useTotal={false}
        toolTip={t('검색 시 코드유형 필터가 비활성화됩니다.')}
      />
    </>
  );
};

export default CodeSetting;
